import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=ca8b848e&scoped=true&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"
import style0 from "./Resources.vue?vue&type=style&index=0&id=ca8b848e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8b848e",
  null
  
)

export default component.exports